import styled, { createGlobalStyle } from "styled-components";

export const MOBILE_BREAKPOINT = "576px";

export const STORYBOOK_HEADER_USERINFO_HIDE_MAX = "750px";

export const AVATAR_HIDE_MAX = "399px";

export const SIDEBAR_DRAWER_TRANSITION = "transform 0.3s ease";

export const TeiaInnerPage = styled.div.attrs({ className: "teia-inner-page" })`
  position: relative;
`;

export const SidebarBackdrop = styled.div<{ $visible: boolean }>`
  display: none;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 55;
  transition: opacity 0.2s ease;

  @media screen and (max-width: ${MOBILE_BREAKPOINT}) {
    display: ${({ $visible }) => ($visible ? "block" : "none")};
  }
`;

export const MobileHamburgerWrap = styled.li`
  display: none !important;
  align-items: center;
  padding: 0;
  border-left: none !important;
  list-style: none;
  margin-right: auto;
  order: -1;

  @media screen and (max-width: ${MOBILE_BREAKPOINT}) {
    display: flex !important;
  }
`;

export const MobileHamburger = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 8px;
  cursor: pointer;
  font-size: 1.25rem;
  border-radius: 4px;

  color: #6b7280 !important;

  svg {
    color: #6b7280 !important;
    fill: currentColor;
  }

  &:hover {
    background: rgba(46, 49, 57, 0.06);

    &,
    svg {
      color: var(--secondary-g, #6b7280);
    }
  }

  &:focus-visible {
    outline: 2px solid var(--primary);
    outline-offset: 2px;
  }
`;

export const MobileSidebarCloseBar = styled.div<{ $open: boolean }>`
  display: none;

  @media screen and (max-width: ${MOBILE_BREAKPOINT}) {
    display: block;
    transform: ${({ $open }) => ($open ? "translateX(0)" : "translateX(-100%)")};
    transition: ${SIDEBAR_DRAWER_TRANSITION};
  }

  position: fixed;
  left: 0;
  top: 0;
  width: 255px;
  max-width: 85vw;
  height: 52px;
  z-index: 61;
  pointer-events: none;
  box-sizing: border-box;
`;

export const MobileSidebarCloseButton = styled.button`
  position: absolute;
  right: 8px;
  top: max(8px, env(safe-area-inset-top, 0px));
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  padding: 0;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  pointer-events: auto;
  background: transparent;
  color: #fff;
  box-shadow: none;

  svg {
    width: 1.375rem;
    height: 1.375rem;
    color: inherit;
    fill: currentColor;
  }

  &:hover {
    filter: brightness(0.9);
  }

  &:focus-visible {
    outline: 2px solid var(--text-over-primary, #fafafa);
    outline-offset: 2px;
  }
`;

/**
 * Estilos de layout mobile para InnerPage.
 * Regras que afetam o aside / toggle DEVEM ficar apenas em max-width: 576px.
 * O reset em min-width: 577px evita que transform/display mobile vazem e quebrem o toggle desktop (span após o aside).
 */
export const TeiaMobileSidebarGlobalStyles = createGlobalStyle`
  @media screen and (min-width: 577px) {
    .teia-inner-page aside:first-of-type {
      transform: none !important;
    }

    .teia-inner-page aside:first-of-type + * {
      display: flex !important;
    }
  }

  @media screen and (max-width: ${MOBILE_BREAKPOINT}) {
    .teia-inner-page aside:first-of-type {
      display: block !important;
      width: 255px !important;
      max-width: 85vw !important;
      transform: translateX(-100%);
      transition: ${SIDEBAR_DRAWER_TRANSITION};
      z-index: 60;
      box-shadow: 2px 0 12px rgba(0, 0, 0, 0.15);
    }

    .teia-inner-page aside:first-of-type:not(.closed) {
      transform: translateX(0);
    }

    .teia-inner-page aside:first-of-type.closed {
      transform: translateX(-100%);
    }

    /* Storybook toggle may be span/button/div — hide any direct sibling of the aside. */
    .teia-inner-page aside:first-of-type + * {
      display: none !important;
    }

    /* NavRight do NewPageTop: className "col p-0 d-flex" (+ hash styled-components, ex. .eCmHgI) */
    .teia-inner-page div.col.p-0.d-flex {
      text-align: right;
      padding-left: 0;
      -webkit-box-pack: justify;
      -webkit-justify-content: space-between;
      -ms-flex-pack: justify;
      justify-content: space-between;
    }

    .teia-inner-page div.col.p-0.d-flex > ul.nav-menus > li {
      position: relative;
      border-left: 1px solid rgb(239, 240, 241);
      padding: 0 15px;
    }

    /* Storybook usa width/margin no primeiro li; no mobile libera layout (hamburger com order -1) */
    .teia-inner-page div.col.p-0.d-flex > ul.nav-menus > li:first-child {
      width: auto !important;
      margin: 0 !important;
    }
  }

  @media screen and (max-width: ${STORYBOOK_HEADER_USERINFO_HIDE_MAX}) {
    .teia-inner-page ul.nav-menus > div.d-flex.media.align-items-center > div:first-of-type {
      display: flex !important;
      flex-direction: column;
      padding: 5px;
      margin: 10px;
      min-width: 0;
      flex: 1;
    }
  }

  @media screen and (max-width: ${AVATAR_HIDE_MAX}) {
    .teia-inner-page ul.nav-menus > div.d-flex.media.align-items-center img[alt="avatar"] {
      display: none !important;
    }
  }
`;
